import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/meetings`;

export const getMeetingList = async (lat, lng, cursor = null) => {
    const params = new URLSearchParams({
        lat: lat.toString(),
        lng: lng.toString()
    });

    if (cursor) {
        params.append('cursor', cursor);
    }

    const response = await axios.get(`${API_BASE_URL}?${params.toString()}`);
    return response.data;
};

export const getMeetingById = async (meetingId) => {
    const response = await axios.get(`${API_BASE_URL}/${meetingId}`);
    return response.data;
};

export const deleteMeetingById = async (meetingId) => {
    const response = await axios.delete(`${API_BASE_URL}/${meetingId}`);
    return response.data;
};

export const createMeeting = async (meetingData) => {
  const response = await axios.post(`${API_BASE_URL}/create`, meetingData);
  return response;
};

export const updateMeeting = async (meetingId, updateData) => {
    const response = await axios.patch(`${API_BASE_URL}/${meetingId}`, updateData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};

export const getMeetingMap = async (lat, lng) => {
    const params = new URLSearchParams({
        lat: lat.toString(),
        lng: lng.toString()
    });

    const response = await axios.get(`${API_BASE_URL}/map?${params.toString()}`);
    return response.data;
};

export const getHostedMeetingList = async () => {
    const response = await axios.get(`${API_BASE_URL}/hosted`);
    return response.data;
};

export const getJoinedMeetingList = async () => {
    const response = await axios.get(`${API_BASE_URL}/joined`);
    return response.data;
};

export const searchMeetings = async (lat, lng, query, recruitingOnly = true) => {
    const response = await axios.get(`${API_BASE_URL}/search`, {
        params: {
            lat: lat,
            lng: lng,
            query: query,
            recruitingOnly: recruitingOnly
        }
    });
    return response.data;
};

export const confirmMeeting = async (meetingId) => {
    const response = await axios.patch(`${API_BASE_URL}/${meetingId}/status`, {});
    return response.data;
};
